import moment from 'moment';
var ValueToApiParser = /** @class */ (function () {
    function ValueToApiParser(type, key, value, liked) {
        this.typeFn = this[type] || this.text;
        this.pKey = key;
        this.pValue = value;
        this.pLiked = liked;
    }
    ValueToApiParser.prototype.parse = function () {
        return this.typeFn();
    };
    ValueToApiParser.prototype.transformDate = function (dateValue) {
        return moment(dateValue, 'DD/MM/YYYY').toISOString();
    };
    ValueToApiParser.prototype.text = function () {
        return this.pLiked ? this.pKey + "=%" + this.pValue + "%" : this.pKey + "=" + this.pValue;
    };
    ValueToApiParser.prototype.date = function () {
        if (typeof this.pValue === 'string') {
            return this.pKey + "=" + this.pValue;
        }
        else {
            var dates = [];
            if (this.pValue.start) {
                dates.push(this.pKey + ">=" + this.transformDate(this.pValue.start));
            }
            if (this.pValue.end) {
                dates.push(this.pKey + "<=" + this.transformDate(this.pValue.end));
            }
            return dates.join(';');
        }
    };
    ValueToApiParser.prototype.select = function () {
        if (typeof this.pValue !== 'object' || this.pValue.length <= 0) {
            return;
        }
        return this.pKey + "=" + this.pValue.join('||');
    };
    return ValueToApiParser;
}());
export default ValueToApiParser;
//# sourceMappingURL=ValueToApiParser.js.map